<template>
  <div class="text-center">
    <v-dialog persistent v-model="profileModalOpen" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">Raise Request

          <div class="spacer"></div>
        <CButtonClose @click="closeModal()" />
        </v-card-title>
         
        <v-card-text>
          <div>
            <v-form ref="requestForm" v-model="valid" lazy-validation>
              <v-text-field
                v-model="formData.user_name"
                :rules="nameRules"
                label="Enter Name"
                name="userName"
                id="userName"
                required
                :disabled="formData.user_name.length != 0"
              ></v-text-field>

              <v-text-field
                v-model="formData.mobile"
                :rules="mobileRules"
                label="Enter Mobile"
                required
                name="userMobile"
                id="userMobile"
                :disabled="formData.mobile.length != 0"
              ></v-text-field>

              <v-text-field
                v-model="formData.email"
                :rules="emailRules"
                label="Enter Email"
                required
                name="userEmail"
                id="userEmail"
                :readonly="emailAlreadyPresent"
              ></v-text-field>

              <v-select
                v-model="formData.ticket_type"
                :items="items"
                :rules="[(v) => !!v || 'Item is required']"
                label="Select Category"
                required
                name="userCategory"
                id="userCategory"
              ></v-select>

              <v-text-field
                v-model="formData.subject"
                :rules="subjectRules"
                label="Enter Subject"
                required
                name="userSubject"
                id="userSubject"
              ></v-text-field>

              <v-textarea
                outlined
                v-model="formData.discription"
                :rules="discriptionRules"
                label="Enter Discription"
                required
                name="userDiscription"
                id="userDiscription"
              ></v-textarea>

              <div class="text-right">
                <v-btn :disabled="!valid" color="success" class="mr-4" @click="submitForm()">Submit</v-btn>
                <v-btn color="error" class="mr-4" @click="closeModal()">Cancel</v-btn>
              </div>
            </v-form>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import config from "@/config.js";
export default {
  props: ["profileData"],
  data() {
    return {
      valid: true,
      nameRules: [v => !!v || "Name is required"],
      mobileRules: [
        v => !!v || "Mobile no is required",
        v => (v && v.length <= 10) || "NO be less than 10 "
      ],
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],

      subjectRules: [v => !!v || "Subject is required"],

      discriptionRules: [v => !!v || "Discription is required"],

      items: ["Query", "Suggestion", "Feedback", "Complaint"],
      formData: {
        user_name: "",
        mobile: "",
        email: "",
        ticket_type: "",
        subject: "",
        discription: "",
        created_by: this.userDetails ? this.userDetails._id : null,
        imageval: null
      },
      emailAlreadyPresent: false
    };
  },
  computed: {
    profileModalOpen() {
      return this.$store.state.general.openProfileModal;
    },
    userDetails() {
      return this.$store.state.general.userDeatils;
    }
  },
  methods: {
    closeModal() {
      this.$refs.requestForm.resetValidation();
      this.$store.commit("general/setProfileFormModal", { roleDialog: false });
      this.formData.ticket_type = "";
      this.formData.subject = "";
      this.formData.discription = "";
      this.formData.created_by = this.userDetails ? this.userDetails._id : null;
      this.formData.imageval = null;
      this.formData.user_name = this.userDetails.full_name;
      this.formData.mobile = this.userDetails.mobile;
      this.formData.email = this.userDetails.email;
    },
    submitForm() {
      if (this.$refs.requestForm.validate()) {
        let obj = {
          user_name: this.userDetails
            ? this.userDetails.full_name
            : this.formData.user_name,
          mobile: this.userDetails
            ? this.userDetails.mobile
            : this.formData.mobile,
          email: this.userDetails.is_email_verified
            ? this.userDetails.email
            : this.formData.email,
          description: this.formData.discription,
          subject: this.formData.subject,
          ticket_type: this.formData.ticket_type.toLowerCase(),
          // assigned_team: reqBody.assigned_team,
          created_by: this.userDetails ? this.userDetails._id : null,
          // imageval: this.attachment,
          assigned_user_status: "pending",
          assigned_team: "support"
        };
        let url = config.BASE_URL + "api/v2/admin/user/ticket/create";
        this.$http.post(url, obj).then(response => {
          if (response.body.status) {
            this.ticketModal = false;
            this.$swal({
              text: "Request Raised Successfully!",
              icon: "success",
              allowOutsideClick: false,
              showCancelButton: false,
              confirmButtonText: "Ok"
            });
            this.closeModal();
          }
        });
      }
    }
  },
  watch: {
    profileData: function(newProfileData, oldProfileData) {
      this.formData.user_name = newProfileData.full_name
        ? newProfileData.full_name
        : "";
      this.formData.mobile = newProfileData.mobile ? newProfileData.mobile : "";
      this.formData.email = newProfileData.email ? newProfileData.email : "";
      this.emailAlreadyPresent = newProfileData.email ? true : false;
    }
  }
};
</script>
<style lang="scss">
.cross-svg{
  svg{
    width:1.3rerm;
  }
}
</style>